import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Settings2, ShieldCheck, Play, ListChecks, FlaskConical, CheckCircle2, Wrench, Bot, Target, RefreshCw } from "lucide-react";

const KIND = {
  CONFIG: { icon: Settings2, tone: "amber" },
  APPROVE: { icon: ShieldCheck, tone: "cyan" },
  ACTIVATE: { icon: Play, tone: "emerald" },
  MILESTONE: { icon: ListChecks, tone: "cyan" },
  TEST: { icon: FlaskConical, tone: "amber" },
  VERIFY: { icon: CheckCircle2, tone: "emerald" },
  ADJUST: { icon: Wrench, tone: "orange" },
  BUILD: { icon: Bot, tone: "amber" },
  DEPENDENCY: { icon: Target, tone: "amber" },
  REAUDIT: { icon: RefreshCw, tone: "cyan" },
};

const TONES = {
  amber: "text-amber-400", cyan: "text-cyan-400", emerald: "text-emerald-400", orange: "text-orange-400",
};

export function NextActionCard({ action, compact = false }) {
  const navigate = useNavigate();
  if (!action) return null;
  const meta = KIND[action.kind] || KIND.BUILD;
  const Icon = meta.icon;
  const tone = TONES[meta.tone] || TONES.amber;

  return (
    <div className="card-arch p-5 sm:p-6 border-amber-500/25 min-w-0" data-testid="next-best-action">
      <div className="halo" />
      <div className="relative">
        <div className={`flex items-center gap-2 ${tone}`}>
          <Icon className="h-4 w-4 shrink-0" />
          <span className="mono-label">Siguiente mejor acción</span>
        </div>
        <h3 className="mt-3 font-head text-lg sm:text-xl font-bold text-white leading-snug break-words" data-testid="next-action-title">{action.title}</h3>
        {action.why && <p className="mt-2 text-sm text-slate-400 break-words">{action.why}</p>}
        {action.context && !compact && (
          <p className="mt-2 text-xs text-slate-500 truncate">Objetivo: <span className="text-slate-400">{action.context}</span></p>
        )}
        <Button data-testid="next-action-cta" onClick={() => navigate(action.cta_path)}
          className="mt-4 w-full sm:w-auto bg-amber-500 text-black hover:bg-amber-400 rounded-full font-semibold">
          {action.cta_label} <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
